export default __webpack_public_path__ + "static/media/avon-principal.406cbe98.png";